import { createGlobalStyle } from 'styled-components/macro'
import { theme } from './theme'

export const GlobalStyleLight = createGlobalStyle`
  :root {
    --text-color: ${theme.colors.textDark} !important;
    --background-color: ${theme.colors.text} !important;
    --background: ${theme.colors.text} !important;
  }
`
